/* eslint-disable prefer-destructuring */
import { v4 as uuid } from 'uuid';
import { equalArrays } from '../components/@base/@uteis';
import { CHANNEL_TO_WATSON } from './DialogDTO';

export const MAP_CONDITION_FROM_WATSON = {
  intent: 'intenção',
  entity: 'entidade',
  special_condition: 'condição especial',
  contextVariable: 'variável de contexto',
  '&&': 'e',
  '||': 'ou',
  '==': '==',
  ':': 'é igual a',
  '!=': 'não é igual a',
  '>': 'é maior que',
  '<': 'é menor que',
  existir: 'existir',
  welcome: 'conversa iniciada por chatbot',
  conversation_start: 'conversa iniciada',
  anything_else: 'transbordo',
  true: 'sempre reconhecer',
  false: 'nunca reconhecer',
  irrelevant: 'mensagem irrelevante para Watson',
};

export const MAP_CONDITION_TO_WATSON = {
  intenção: '#',
  entidade: '@',
  'variável de contexto': '$',
  e: '&&',
  ou: '||',
  '==': '==',
  'é igual a': ':',
  'não é igual a': '!=',
  'é maior que': '>',
  'é menor que': '<',
  existir: '',
  'condição especial': '',
  'conversa iniciada por chatbot': 'welcome',
  'conversa iniciada': 'conversation_start',
  transbordo: 'anything_else',
  'sempre reconhecer': 'true',
  'nunca reconhecer': 'false',
  'mensagem irrelevante para Watson': 'irrelevant',
};

export const SPECIAL_CONDITTIONS = [MAP_CONDITION_FROM_WATSON.welcome,
MAP_CONDITION_FROM_WATSON.conversation_start, MAP_CONDITION_FROM_WATSON.anything_else,
MAP_CONDITION_FROM_WATSON.false, MAP_CONDITION_FROM_WATSON.true,
MAP_CONDITION_FROM_WATSON.irrelevant];

const SPECIAL_CONDITTIONS_REGEX = /welcome|conversation_start|anything_else|true|false|irrelevant/;
export default class DialogConditionDTO {
  constructor(id, type = 'intent', relationalOperator = '&&', object = ' ', logicalOperator = '', comparedValue = '') {
    this.id = id;
    this.relationalOperator = MAP_CONDITION_FROM_WATSON[relationalOperator];
    this.type = MAP_CONDITION_FROM_WATSON[type];
    this.object = object;
    this.logicalOperator = !logicalOperator
      ? MAP_CONDITION_FROM_WATSON.existir : MAP_CONDITION_FROM_WATSON[logicalOperator];
    this.comparedValue = comparedValue;
  }

  static buildList = (baseCondition) => {
    if (!baseCondition && baseCondition.trim().length === 0) return null;
    const parts = baseCondition.split(/(&&|\|\|)/);
    const conditions = parts.map((value, index) => {
      if (index % 2 !== 0) return false;
      const part = value.trim();

      const relationalOperator = index > 0 ? unescape(parts[index - 1]) : null;
      let type = null;
      let object = null;
      let logicalOperator = null;
      let comparedValue = null;

      if (SPECIAL_CONDITTIONS_REGEX.test(part)) {
        type = 'special_condition';
        object = MAP_CONDITION_FROM_WATSON[part];
      } else {
        switch (part[0]) {
          case '@': {
            type = 'entity'; break;
          }
          case '$': {
            type = 'contextVariable'; break;
          }
          default: {
            type = 'intent';
          }
        }

        object = part.match(/(#|@|\$)[\wÀ-ú0-9_\-.]+/);
        if (object) object = object[0].substring(1);

        logicalOperator = part.match(/(!=|>|<|:|==)/) || null;
        if (logicalOperator) logicalOperator = logicalOperator[0].trim();

        comparedValue = part.match(/(?<=(!=|>|<|:|==)).+/) || null;
        if (comparedValue) comparedValue = comparedValue[0].replace(/\(|\)|'|"/g, '').trim();
      }

      return new DialogConditionDTO(
        uuid(),
        type,
        relationalOperator,
        object,
        logicalOperator,
        comparedValue,
      );
    });
    return conditions.filter((c) => c);
  }

  static parseList = (conditionList) => {
    if (!conditionList) return null;
    let retorno = '';
    conditionList.forEach((condition, index) => {
      let relationalOperator = '';
      if (index !== 0) {
        relationalOperator = condition.relationalOperator
          ? `${MAP_CONDITION_TO_WATSON[condition.relationalOperator]} ` : '';
      }

      const type = MAP_CONDITION_TO_WATSON[condition.type];

      let object = condition.object;
      if (condition.type === MAP_CONDITION_FROM_WATSON.special_condition) {
        object = MAP_CONDITION_TO_WATSON[object];
      }

      const logicalOperator = condition.logicalOperator
        ? MAP_CONDITION_TO_WATSON[condition.logicalOperator] : '';

      let comparedValue = condition.comparedValue
        ? condition.comparedValue : '';
      if (comparedValue.includes(' ')) comparedValue = `(${comparedValue})`;
      retorno = `${retorno} ${relationalOperator}${type}${object}${logicalOperator}${comparedValue}`;
    });

    return retorno.trim();
  }

  static validate = (condition) => {
    if (!condition.type || condition.type.trim() === '') return false;
    if (!condition.object || condition.object.trim() === '') return false;

    if (condition.logicalOperator
      && condition.logicalOperator !== MAP_CONDITION_FROM_WATSON.existir
      && (!condition.comparedValue || condition.comparedValue.trim() === '')) {
      return false;
    }
    return true;
  }

  static buildFromEnabledChannels = (enabledChannels) => {
    if (equalArrays(enabledChannels, Object.keys(CHANNEL_TO_WATSON))) {
      return [];
    }
    return enabledChannels.map((channel) => new DialogConditionDTO(
      uuid(),
      'contextVariable',
      '&&',
      'sb_channel',
      '==',
      `'${CHANNEL_TO_WATSON[channel]}'`,
    ));
  }
}
